module.exports = __webpack_public_path__ + "img/neftci.e3916335.png";